import { Models } from "@/api/types";
import { Text } from "@/atoms";
import { ReferralRewardsReferralHistoryEntry } from "@/modules/referralRewards";

type ReferralRewardsReferralHistoryProps = {
  history?: Models<"DisplayReferralHistoryItemForPerson">[];
};

export const ReferralRewardsReferralHistory = ({
  history = [],
}: ReferralRewardsReferralHistoryProps) => {
  const unusedLinkCount = history?.filter(
    (historyEntry) => historyEntry.attributionState === "Unused"
  )?.length;

  const renderNoHistory = () =>
    !history?.length && (
      <div className={"relative flex items-center bg-white py-2 pl-6 pr-6"}>
        <div className="flex flex-col items-start justify-center gap-3 py-2">
          <Text
            variant="body1"
            className="text-black"
            text="Your referral journey begins here! Invite friends to unlock rewards."
          />
        </div>
      </div>
    );

  const renderUnusedLinksMessage = () =>
    unusedLinkCount > 0 &&
    !history?.length && (
      <div className="flex flex-col items-start justify-center gap-3 bg-gray-50 px-6 py-8">
        <Text
          variant="body3"
          className="text-black"
          text="If you sent some invites, their activity will show up here when they sign up."
        />
      </div>
    );

  return (
    <div
      className="bg-gray-50 pb-6 pt-6"
      data-testid="ReferralRewardsReferralHistory"
    >
      <div className="mb-2 px-4">
        <Text
          variant="h2"
          className="text-start text-sub2 uppercase text-black"
          text="Referral History"
        />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col divide-y divide-solid divide-background-two overflow-clip border-y-[1px] border-y-background-two">
          {renderNoHistory()}
          {renderUnusedLinksMessage()}
          {history?.map((historyEntry, index) => (
            <ReferralRewardsReferralHistoryEntry
              key={historyEntry.statelessShareUrlId + index}
              historyEntry={historyEntry}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
